module.exports = __webpack_public_path__ + "static/media/csm-headset.ee3536ff.svg";